module.exports = "/_next/static/images/404-842e83cf36f022242ad62f16d0c61360.png";